import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ModalContentBlock } from '../../pages/components/';
import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import * as userActions from '../user.actions';
import ForgotPasswordForm from './ForgotPasswordForm';

import Button from '../../../ui/button/Button';
import colorThemes from '../../../ui/colorThemes';
import { Localize } from '../../../locale/localization';

const constraints = {
  email: {
    email: {
      message: `^${Localize('form.forgot-password.email.error')}`
    }
  },
};

const baseFormData = {
  email: '',
};

class ForgotPasswordFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      formData: Object.assign({}, baseFormData),
    };
  }

  getConstraints = () => constraints;

  doSubmit = (formData) => {
    const { forgotPassword } = this.props;
    forgotPassword(formData).then((action) => {
      if(action && action.response && action.response.status === 'ok') {
        this.setState({
          submitCompleted: true,
          submitted: true,
        });
      } else {
        this.setState({
          submitFailed: true,
          submitted: true,
        });
      }
    });
  }

  onCancel = (event) => {
    event.preventDefault();
    
    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  }

  onReset = (event) => {
    event.preventDefault();
    this.reset();
    this.setState({
      formData: Object.assign({}, baseFormData),
    });
  }

  render() {
    return (
      <ModalContentBlock title={Localize('password.forgot')}>
        {!this.state.submitted ? (
          <div>
            <p>Näitähän sattuu. Syötä alle sähköpostisi, niin lähetämme ohjeet salasanan palauttamiseen.</p>
            <ForgotPasswordForm
              enabled={!this.state.isSubmitting}
              onSubmit={this.onSubmit}
              onCancel={this.onCancel}
              onInputChange={this.onInputChange}
              onBlur={this.onBlur}
              errors={this.state.errors}
              touchedFields={this.state.touchedFields}
              isValid={this.state.isValid}  
              email={this.state.formData.email}
            />
          </div>
        ) : (
          this.state.submitCompleted ? (
            <div>
              <p>Tarkasta sähköpostisi – Lähetimme ohjeet salasanan palauttamiseen.</p>
              <Button theme={colorThemes.LIGHT} onClick={this.onCancel}>Sulje</Button>
            </div>
          ) : (
            <div>
              <p>Käyttäjätunnus ei rekisterissä. Käytä sähköpostiosoitetta, jonka kautta sait kutsun C More Sisäpiiriin.</p>
              <Button theme={colorThemes.LIGHT} onClick={this.onReset}>Yritä uudelleen</Button>
            </div>
          )
        )}
      </ModalContentBlock>
    );
  }
}

const mapStateToProps = (state, { cancelPath }) => {
  return {
    cancelPath,
  };
};

const ConnectedForgotPasswordFormContainer = connect(
  mapStateToProps,
  userActions,
)(ForgotPasswordFormContainer);

export default withRouter(ConnectedForgotPasswordFormContainer);


// WEBPACK FOOTER //
// ./src/modules/user/components/ForgotPasswordFormContainer.js